import 'babel-polyfill';
import fromEntries from 'object.fromentries';
import arrayFlat from 'array.prototype.flat';

if (!Object.fromEntries) {
    fromEntries.shim();
}

if (!Array.prototype.flat) {
    arrayFlat.shim();
}

if ( !HTMLFormElement.prototype.reportValidity ) {
    HTMLFormElement.prototype.reportValidity = function() {
        var submitButtons = this.querySelectorAll( "button, input[type=submit]" );
        for ( var i = 0; i < submitButtons.length; i++ ) {
            // Filter out <button type="button">, as querySelectorAll can't
            // handle :not filtering
            if ( submitButtons[ i ].type === "submit" ) {
                submitButtons[ i ].click();
                return;
            }
        }
    }
}

// Prevent global keyboard handlers from closing modals when the user types
// inside inputs inside a modal. Some global listeners (keyboard shortcuts,
// accessibility helpers, etc.) listen on document and don't check for focus
// being inside a modal which can cause the modal to unexpectedly close when
// typing. Stop propagation for keydown events originating from elements
// inside any Bootstrap/Vue modal (.modal) so local inputs receive the events
// but global handlers don't.
document.addEventListener('keydown', function (ev) {
    try {
        var tgt = ev.target || ev.srcElement;
        if (!tgt || !tgt.closest) return;
        if (tgt.closest && tgt.closest('.modal')) {
            // only stop propagation for printable/typing keys, allow escape so
            // modals can still be closed with ESC when desired by user
            var key = ev.key || ev.keyCode;
            // if key is Escape (Esc) do nothing
            if (key === 'Escape' || key === 'Esc' || key === 27) return;
            ev.stopPropagation();
        }
    } catch (e) {
        // swallow errors here to avoid breaking page boot
    }
}, true);
